// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingDots--loader--2OhNQ","bouncedelay":"LoadingDots--bouncedelay--6guKf","dark":"LoadingDots--dark--2MVqT","light":"LoadingDots--light--xlVxd"};